import Vue from 'vue'

// axios TERMINAL
import axios from 'axios'

const axiosIns = axios.create({

  // baseURL: 'http://localhost:8000/api',
  baseURL: 'https://api-staging.aequitex.com/api',
  // baseURL: 'https://api.aequitex.com/api',

  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json',
  },
})

axiosIns.interceptors.request.use((config) => {
  const { default: store } = require('@/store/index')
  const token = store.state.auth?.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

Vue.prototype.$http = axiosIns

export default axiosIns
